import React from "react";
import styled from "styled-components";
import { connect } from 'react-redux';
import {
    COLOR_FOOTER_MOBILE_TEXT,
    COLOR_GREY, COLOR_GREY2, COLOR_LIGHT_GREY,
    COLOR_WHITE
} from "../config/colors";
import themeValue from "../themes/themeValue";

const Footer = function (props) {
    return (
        <FooterComponent enabled={props.location.pathname === '/'}>
            <FooterContainer>
                <DesktopView>
                    <FooterMenu>
                        <FooterMenuItem>
                            <PurpleButton>
                                <HowItWorksLink href={'/'}>🕵&nbsp;&nbsp;how it works</HowItWorksLink>
                            </PurpleButton>
                        </FooterMenuItem>
                        <FooterMenuItem active={props.location.pathname === '/' || props.location.pathname === '/city-search'}>
                            1.) {
                               props.searchType !== 'location'
                                    ? 'Find your college'
                                    : 'Find your location'
                            }
                        </FooterMenuItem>
                        <FooterMenuItem active={props.location.pathname === '/app/housing-questionnaire-your-info' || props.location.pathname === '/app/housing-questionnaire' || props.location.pathname === '/app/housing-questionnaire-move-in-details'}>
                            2.) Answer questions
                        </FooterMenuItem>
                        <FooterMenuItem active={props.location.pathname === '/app/your-matches'}>
                            3.) Match with properties
                        </FooterMenuItem>
                        <FooterMenuItem active={props.location.pathname === '/app/congratulations'}>
                            4.) Live happily ever after
                        </FooterMenuItem>
                    </FooterMenu>
                </DesktopView>
            </FooterContainer>
            <MobileView>
                <FooterMenuItemMobile>
                    🏡&nbsp;&nbsp;100,000+ places to live
                </FooterMenuItemMobile>
                <FooterMenuItemMobile>
                    🎓&nbsp;&nbsp;4,000+ colleges
                </FooterMenuItemMobile>
            </MobileView>
        </FooterComponent>
    )
};

const FooterComponent = styled.div`
    min-height: 44px;
    line-height: 26px;
    color: ${themeValue('footer.textColor')};
    background-color: ${themeValue('footer.backgroundColor')};
    border-top: 1px solid ${themeValue('footer.borderColor')};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;

    @media (max-width: 768px) {
    display: ${props => props.enabled ? 'flex' : 'none'};
  }
`;

const FooterContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const FooterMenu = styled.div`
    display: flex;
`;

const FooterMenuItem = styled.div`
    align-self: center;
    text-align: left;
    margin-right: 30px;
    padding: 7px;
    font-size: 14px;
    line-height: 22px;
    color: ${props => props.active ? themeValue('footer.linkColor') : themeValue('footer.textColor')};
    font-weight: ${props => props.active ? 'bold' : 'normal'};

    @media (max-width: 959px) {
    margin-right: 15px;
  }
`;

const FooterMenuItemMobile = styled.div`
    align-self: center;
    margin-left: 22px;
    font-size: 14px;
    color: ${COLOR_FOOTER_MOBILE_TEXT};
`;

const PurpleButton = styled.div`
    background-color: ${themeValue('button.howItWorks.color')};
    border-radius: 3px;
    padding: 2px;

    @media (min-width: 768px) and (max-width: 969px) {
    text-align: center;
    }
`;

const HowItWorksLink = styled.span`
    color: ${COLOR_WHITE};
    text-transform: uppercase;
    text-decoration: none;
    border-radius: 3px;
    font-weight: 850;
    padding: 5px;
        &:hover {
            color: ${COLOR_WHITE};
            text-decoration: none;
        }
`;

const DesktopView = styled.div`
    @media (max-width: 768px) {
    display: none;
  }
`;

const MobileView = styled.div`
    display: flex;
    @media (min-width: 768px) {
    display: none;
  }
`;

const mapDispatchToProps = dispatch => ({});
const mapStateToProps = state => ({
    searchType: state.common.searchType,
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
